import {ResearchLitElement, html, css} from '@core/research-lit-element';

export class ResearchRouter extends ResearchLitElement {
    static get is() {
        return 'research-router';
    }

    static get styles() {
        // language=CSS
        return css`
            :host {
                display: contents;
            }
        `;
    }

    render() {
        // language=HTML
        return html``;
    }

    static get properties() {
        return {
            route: {
                type: String,
                observer: '_routeChanged',
            },
            path: {type: String},
            pattern: {type: String},
            active: {type: Boolean},
            params: {type: Object},
            tail: {type: String},
            _patternList: {type: Array},
        };
    }

    constructor() {
        super();
        this._patternList = [];
    }

    _routeChanged() {
        this._processPath();
    }

    _processPath() {
        if (!this.pattern || !this.route) return;
        if (this._patternList.length === 0) {
            this._patternList = this.pattern.split('/');
        }
        this.params = {};
        const routeList = this.route.split('/');
        this._patternList.some((part, index) => {
            if (!/^:[a-zA-Z0-9]+$/g.test(part)) {
                if (routeList[index] !== part[index]) {
                    this.active = false;
                    return false;
                }
                return true;
            } else {
                this.params[part.substr(1, part.length)] = routeList[index];
                return false;
            }
        });
        const tails = routeList.slice(this._patternList.length, routeList.length);
        this.tail = tails.length ? '/' + tails.join('/') : null;
        this.active = true;
        if (typeof this.callback !== 'undefined') {
            return this.callback(this.params, this.tail, this.active);
        }
        this.sendCustomEvent('route-changed');
    }
}

window.customElements.define(ResearchRouter.is, ResearchRouter);
